import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const __default__ = {
  name: "MPreview",
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    imgs: {
      type: Array,
      default: []
    }
  },

  setup(__props, {
    emit
  }) {
    const props = __props; // 如果页面有滚动条

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        document.querySelector('body').style.overflow = 'hidden';
      } else {
        document.querySelector('body').style.overflow = '';
      }
    });

    function closePreview() {
      emit('update:modelValue', false);
    }

    return (_ctx, _cache) => {
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");

      return __props.modelValue ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        "url-list": props.imgs,
        teleported: "",
        onClose: closePreview
      }, null, 8, ["url-list"])) : _createCommentVNode("", true);
    };
  }

});